<script lang="ts">
    import { Button, Card, CardBody, CardHeader, Col } from "sveltestrap";
    import { UpcomingCourses, href } from "../../../utils/Constant/Constant";
    import {knowledgeDetail} from "../../../Data/Miscellaneous/KnowledgeBase"
    import Link from "svelte-link";
    import StarRating from "svelte-star-rating";
    let open:boolean = true
      const config = {
        emptyColor:"#fff",
        fullColor: '#e2c636',
        size: 10,
      };
</script>
<Col xl="12">
    <Card>
        <CardHeader>
            <h5 class="mb-0 p-0">
                <Button class="btn-link" on:click={()=> open = !open}>{UpcomingCourses}</Button>
            </h5>
        </CardHeader>
        <div class="collapse {open ? "show" : ""} ">
            <CardBody class="upcoming-course">
                {#each knowledgeDetail as detailItem }
                    <div class="media">
                        <div class="media-body">
                            <span class="f-w-600">{detailItem.title}</span>
                            <h6>Course By <Link href={href}> Lorem ipsum</Link></h6>
                            <ul class="rating">
                                <StarRating rating={5} {config} />
                            </ul>
                        </div>
                        <div>
                            <h5 class="mb-0 p-0 font-primary">{detailItem.date}</h5>
                            <span class="d-block">{detailItem.month}</span>
                        </div>
                    </div>
                {/each}
            </CardBody>
        </div>
    </Card>
</Col>